var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.55613 4.63354C3.25093 3.43441 4.35784 2.52864 5.67076 2.0849C6.98368 1.64115 8.41313 1.68967 9.69294 2.22142C10.9727 2.75317 12.0157 3.73191 12.6276 4.9754C13.2395 6.21888 13.3786 7.64237 13.0191 8.9808C12.6595 10.3192 11.8258 11.4814 10.6732 12.2509C9.52056 13.0204 8.12756 13.3447 6.75357 13.1636C5.37957 12.9825 4.11823 12.3082 3.2044 11.2663C2.29057 10.2244 1.78653 8.88585 1.78613 7.49997",
    stroke: "#1D3557",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.35714 4.64279H2.5V1.78564",
    stroke: "#1D3557",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetIcon);
export default __webpack_public_path__ + "static/media/resetIcon.903d1b2ce4e06db6c78127ea7bc34cc5.svg";
export { ForwardRef as ReactComponent };